import React from "react";
import { Lock, RotateCw } from "lucide-react";
import { FONT, T, focusRing } from "./tokens";

// ===========================================================================
// BrowserChromeBar — the faux browser chrome across the top of the preview
// frame: traffic-light dots, a lock + URL field, and a reload affordance.
// Purely presentational; `onReload` re-mounts the iframe upstream.
// ===========================================================================

function Dot({ color }) {
  return <span style={{ width: 11, height: 11, borderRadius: T.radiusFull, background: color, display: "inline-block" }} />;
}

export default function BrowserChromeBar({ url = "", secure = true, onReload }) {
  const display = (url || "").replace(/^https?:\/\//, "").replace(/\?.*$/, "");
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        height: 40,
        padding: "0 12px",
        background: "rgba(255,255,255,0.7)",
        borderBottom: `1px solid ${T.line}`,
        flexShrink: 0,
      }}
    >
      <div style={{ display: "flex", gap: 7, flexShrink: 0 }} aria-hidden="true">
        <Dot color="#f0b8b1" />
        <Dot color="#f2d9a4" />
        <Dot color="#bfe0c2" />
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 8,
          height: 26,
          padding: "0 12px",
          borderRadius: T.radiusFull,
          background: "rgba(255,255,255,0.9)",
          border: `1px solid ${T.line}`,
          color: T.ink3,
          fontFamily: FONT,
          fontSize: 12.5,
        }}
      >
        {secure && <Lock size={12} strokeWidth={2} style={{ color: T.green, flexShrink: 0 }} aria-hidden="true" />}
        <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: T.ink2 }}>
          {display || "yoursite.com"}
        </span>
      </div>
      <button
        type="button"
        aria-label="Reload preview"
        title="Reload preview"
        onClick={onReload}
        onFocus={(e) => (e.currentTarget.style.boxShadow = focusRing.boxShadow)}
        onBlur={(e) => (e.currentTarget.style.boxShadow = "none")}
        style={{
          width: 28,
          height: 28,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          borderRadius: T.radiusFull,
          background: "transparent",
          color: T.ink3,
          cursor: "pointer",
        }}
      >
        <RotateCw size={14} strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
}
